import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setEdits, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default ColumnSelectShortcuts = ->

  [{
    columns,
    count,
    edits,
    selection,
    selectionType
  }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      dispatch(setSelectionType(selectionTypes.CELL))
      dispatch(setSelection([selection, 0]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'left'
    fn: ->
      dispatch(setSelection(selection - 1))
    temporary: true
    expr: selection > 0
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['right']
    fn: ->
      dispatch(setSelection(selection + 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+left'
    fn: ->
      dispatch(setSelection([selection, selection - 1]))
      dispatch(setSelectionType(selectionTypes.MULTI_COL))
    temporary: true
    expr: selection > 0
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+right'
    fn: ->
      dispatch(setSelection([selection, selection + 1]))
      dispatch(setSelectionType(selectionTypes.MULTI_COL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      newEdits = [0..(count - 1)].reduce((acc, i) ->
        {
          acc...,
          [i]: {
            edits[selection]...,
            acc[selection]...,
            [selection]: emptyCell(columns[selection])
          }
        }
      , edits)

      dispatch(setEdits({
        prevEdits: edits
        nextEdits: newEdits
      }))
    expr: WeaverService.userCanEdit()
    temporary: true
    watchers: [selection, edits]
  }])

  <div />





